module.exports = __webpack_public_path__ + "static/media/giji3.61dcf227.png";